module.exports = __webpack_public_path__ + "media/fonts/SFProDisplay-Light-c3e7f9ca5eac866a8c9b9317a05fcc99.svg";